export default __webpack_public_path__ + "8b1ad7e5d8ca659108c7043237e562bb.svg";